import { EditorMovePageButton } from './EditorMovePageButton';

export const EditorMovePageButtonLoader = EditorMovePageButton;
